export enum SearchFormOptions {
  url = 'url',
  text = 'text',
  equipment = 'equipment',
  image = 'image',
  competitor = 'competitor'
}
